export const BrevoFeatureObj = [
  {
    title: "Keep your subscribers in a single place",
    desc: "Add new subscribers created in CausalFunnel to your Brevo (formerly SendInBlue) account",
  },
  {
    title: "Pre-chat survey",
    desc: "Collect new subscribers when they want to start chatting with you",
  },
  {
    title: "Chatbots",
    desc: "Use lead generation bots to automatically sync new subscribers",
  },
  {
    title: "Manual settings",
    desc: "Change subscribers status manually during a conversation, sync automatically",
  },
];

export const BrevoInstallGuide = [
  { id: 1, content: "Log in to your SendInBlue account" },
  { id: 2, content: "Click on you account options and select 'SMTP & API'" },
  { id: 3, content: "Select 'API Keys' tab" },
  { id: 4, content: "Click 'Generate a new API Key'" },
  { id: 5, content: "Name your Private API Key" },
  {
    id: 6,
    content:
      "Now copy your Private Key and paste it when creating a new connection",
  },
];
